// An interface between the Asset Upload widget and the Asset Upload authoring UI via a service placed in Shell UI.
class assetUploadService {
	constructor(assetUploadFileManager) {
		this.assetUploadFileManager = assetUploadFileManager;
	}

	// Creates a new upload file list and stores them within this service.
	// Return the ID for the new file list
	addFileList(files) {
        return this.assetUploadFileManager.addFileList(files);
	}
	
    // Get the number of upload file lists currently active on this service.
    getNumberOfFileLists() {
        return this.assetUploadFileManager.getNumberOfFileLists();
    }
    
    // Get the string that defines the accepted file types.
    getFileAcceptType() {
        return this.assetUploadFileManager.getFileAcceptType();
    }

    // Get the promise to the string that defines the maximum size accepted for a single file for this tenant.
    getFileMaxSize() {
        return this.assetUploadFileManager.getFileMaxSize();
    }

    // Get the string that defines the default maximum size accepted for a single file.
    getDefaultFileMaxSize() {
        return this.assetUploadFileManager.getDefaultFileMaxSize();
    }

    // Get the string that defines the maximum number of files that can be uploaded in a single upload instance.
    getMaxFilesPerUpload() {
        return this.assetUploadFileManager.getMaxFilesPerUpload();
    }

    // Get the integer that defines the maximum upload instances allowed.
    getMaxUploadInstances() {
        return this.assetUploadFileManager.getMaxUploadInstances();
    }
}

angular
	.module('HomepageServices')
	.service('assetUploadService', ['assetUploadFileManager', assetUploadService]);



// WEBPACK FOOTER //
// ./app/common/assetUploadService.js